export const REDIRECT_TO_SPLASH_SCREEN = '@auth/REDIRECT_TO_SPLASH_SCREEN';

export const redirectToSplashScreen = (
) => ({
    type: REDIRECT_TO_SPLASH_SCREEN,
    payload: {},
});
